var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("entity-editor", {
    attrs: {
      entity: "monster",
      id: _vm.id,
      "new-entity": _vm.newMonster,
      copy: _vm.copy
    },
    on: { isDirtyChange: _vm.handleIsDirtyChange },
    scopedSlots: _vm._u(
      [
        {
          key: `editor`,
          fn: function({ doc }) {
            return [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "9" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Name" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.name,
                          callback: function($$v) {
                            _vm.$set(doc, "name", $$v)
                          },
                          expression: "doc.name"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Section" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.section,
                          callback: function($$v) {
                            _vm.$set(doc, "section", $$v)
                          },
                          expression: "doc.section"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-combobox", {
                        attrs: {
                          items: _vm.races,
                          clearable: "",
                          rules: [_vm.requiredRule],
                          label: "Race",
                          outlined: "",
                          dense: ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.raceChange(doc)
                          }
                        },
                        model: {
                          value: doc.race,
                          callback: function($$v) {
                            _vm.$set(doc, "race", $$v)
                          },
                          expression: "doc.race"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Elemental Weakness",
                          dense: "",
                          readonly: "",
                          outlined: "",
                          filled: ""
                        },
                        model: {
                          value: doc.elementalWeakness,
                          callback: function($$v) {
                            _vm.$set(doc, "elementalWeakness", $$v)
                          },
                          expression: "doc.elementalWeakness"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.patternTypes,
                          disabled: _vm.isLoading,
                          label: "Pattern Type",
                          outlined: "",
                          dense: "",
                          "return-object": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.patternChange(doc, $event)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Pattern Type" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.patternType,
                          callback: function($$v) {
                            _vm.$set(doc, "patternType", $$v)
                          },
                          expression: "doc.patternType"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Pattern Type Effect",
                          dense: "",
                          "return-object": "",
                          readonly: "",
                          rows: "2",
                          outlined: "",
                          "auto-grow": "",
                          filled: ""
                        },
                        model: {
                          value: doc.patternTypeEffect,
                          callback: function($$v) {
                            _vm.$set(doc, "patternTypeEffect", $$v)
                          },
                          expression: "doc.patternTypeEffect"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4" } },
                    [
                      _c("v-select", {
                        attrs: {
                          rules: [_vm.requiredRule],
                          items: _vm.intelligence,
                          disabled: _vm.isLoading,
                          label: "Intelligence",
                          outlined: "",
                          dense: "",
                          "return-object": ""
                        },
                        on: {
                          change: function($event) {
                            return _vm.intelligenceChange(doc, $event)
                          }
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Intelligence" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.intelligence,
                          callback: function($$v) {
                            _vm.$set(doc, "intelligence", $$v)
                          },
                          expression: "doc.intelligence"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Intelligence",
                          dense: "",
                          readonly: "",
                          rows: "2",
                          outlined: "",
                          "auto-grow": "",
                          filled: ""
                        },
                        model: {
                          value: doc.intelligenceEffect,
                          callback: function($$v) {
                            _vm.$set(doc, "intelligenceEffect", $$v)
                          },
                          expression: "doc.intelligenceEffect"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Hits", rules: [_vm.requiredRule] },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Hits" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.hits,
                          callback: function($$v) {
                            _vm.$set(doc, "hits", $$v)
                          },
                          expression: "doc.hits"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Armour" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: `label`,
                              fn: function() {
                                return [
                                  _c("label-required", {
                                    attrs: { name: "Armour" }
                                  })
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: doc.armour,
                          callback: function($$v) {
                            _vm.$set(doc, "armour", $$v)
                          },
                          expression: "doc.armour"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Dismiss/Control" },
                        model: {
                          value: doc.dismissControl,
                          callback: function($$v) {
                            _vm.$set(doc, "dismissControl", $$v)
                          },
                          expression: "doc.dismissControl"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Immunities",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.immunities,
                          callback: function($$v) {
                            _vm.$set(doc, "immunities", $$v)
                          },
                          expression: "doc.immunities"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Strikes For",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.strikesFor,
                          callback: function($$v) {
                            _vm.$set(doc, "strikesFor", $$v)
                          },
                          expression: "doc.strikesFor"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Summoning Ability",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.summoningAbility,
                          callback: function($$v) {
                            _vm.$set(doc, "summoningAbility", $$v)
                          },
                          expression: "doc.summoningAbility"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Ability One",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.abilityOne,
                          callback: function($$v) {
                            _vm.$set(doc, "abilityOne", $$v)
                          },
                          expression: "doc.abilityOne"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Ability Two", outlined: "" },
                        model: {
                          value: doc.abilityTwo,
                          callback: function($$v) {
                            _vm.$set(doc, "abilityTwo", $$v)
                          },
                          expression: "doc.abilityTwo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Ability Three",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.abilityThree,
                          callback: function($$v) {
                            _vm.$set(doc, "abilityThree", $$v)
                          },
                          expression: "doc.abilityThree"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Notes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.restrictionsAndNotes,
                          callback: function($$v) {
                            _vm.$set(doc, "restrictionsAndNotes", $$v)
                          },
                          expression: "doc.restrictionsAndNotes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Roleplay Guidelines",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.roleplayGuidelines,
                          callback: function($$v) {
                            _vm.$set(doc, "roleplayGuidelines", $$v)
                          },
                          expression: "doc.roleplayGuidelines"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Makeup Notes",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.makeupNotes,
                          callback: function($$v) {
                            _vm.$set(doc, "makeupNotes", $$v)
                          },
                          expression: "doc.makeupNotes"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("v-textarea", {
                        attrs: {
                          label: "Upstats",
                          rows: "2",
                          outlined: "",
                          "auto-grow": ""
                        },
                        model: {
                          value: doc.upstats,
                          callback: function($$v) {
                            _vm.$set(doc, "upstats", $$v)
                          },
                          expression: "doc.upstats"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }